<template>
  <div class="hello">
    <div
      @click="connectMe"
      style="position: fixed;bottom: 52px;width: 94%;height: 46px;background: rgb(255 255 255);font-size: 15px;margin-top: 10px px;margin-bottom: 5px;text-align: center;margin-left: 15px;margin-right: 15px;border-radius: 6px;"
    >
      <van-row>
        <van-col span="12">
          <div
            style="height: 46px;line-height: 46px;display: flex;align-items: center;justify-content: center;"
          >
            <img
              src="https://www.ptty.com.cn/wap/sph.png?v=20250530"
              style="width:25px"
            />
            <span style="margin-left: 4px;position: relative;top: 1px;"
              >关注视频号</span
            >
          </div>
        </van-col>
        <van-col span="12">
          <div
            style="height: 46px;line-height: 46px;display: flex;align-items: center;justify-content: center;"
          >
            <img
              src="https://www.ptty.com.cn/wap/gzh.png?v=20250530"
              style="width:25px"
            />
            <span style="margin-left: 4px;position: relative;top: 1px;"
              >关注公众号</span
            >
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: String,
      default: ""
    }
  },
  methods: {
    connectMe() {
      this.$router.push({ path: "/connectMe" });
    },
    nacToZy() {
      var routeValue = localStorage.getItem("routeValue");
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/" + routeValue });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/commonCom/BottomCom.vue